/**
 * «Сегодня» в календаре пользователя (локальная дата), а не по UTC.
 *
 * `new Date().toISOString().slice(0, 10)` до 05:00 по Ташкенту (UTC+5) даёт
 * вчерашнюю дату — срез, шкала и подписи расходились бы с календарём на стене.
 */
export function localIsoDate(at: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`;
}
